<script>
export default {
  props: {
    size: {
      type: String,
      default: '18',
    },
  },
}
</script>
<template>
  <svg
    style="fill: currentColor"
    viewBox="0 0 10 6"
    :width="size"
    :height="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.573185 0.926776C0.866078 0.633883 1.34095 0.633883 1.63385 0.926776L5.10352 4.39645L8.57319 0.926776C8.86608 0.633882 9.34095 0.633882 9.63385 0.926776C9.92674 1.21967 9.92674 1.69454 9.63385 1.98744L5.9874 5.63388C5.49924 6.12204 4.70779 6.12204 4.21963 5.63388L0.573185 1.98744C0.280292 1.69454 0.280292 1.21967 0.573185 0.926776Z"
    />
  </svg>
</template>
